/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { getProduction } from 'redux/reducers/productions';
import { withRouter } from 'react-router-dom';
import actions from 'redux/actions';

import DataLoader from 'components/DataLoader';
import ProductionInfo from 'components/ProductionInfo';

import styles from './styles.module.scss';

import type { Fetchable, Production, ReduxState } from 'types';
import type { ContextRouter } from 'react-router-dom';

const mapStateToProps = (state: ReduxState) => {
  return {
    production: getProduction(state),
  };
};

type Props = ContextRouter & {
  production: Fetchable<Production>,
};

class ProductionShow extends React.Component<Props, void> {
  _renderData = data => {
    return (
      <div className={styles.container}>
        <ProductionInfo {...data} />
      </div>
    );
  };

  render() {
    const {
      production: { fetching, error, data },
    } = this.props;
    return <DataLoader loading={fetching} error={error} data={data} render={this._renderData} />;
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    actions
  )(ProductionShow)
);
